module.exports = __webpack_public_path__ + "static/media/IMG_7850.d6920e52.JPG";